// extracted by mini-css-extract-plugin
module.exports = {"container":"Iv2P","header":"jyfy","heading":"_89PX","icons":"fevz","smalltext":"_-392"};